export default __webpack_public_path__ + "static/media/information.d56ff58a.jpg";